const atob = require('atob');

/**
 * Decodes a JSON Web Token (JWT) and returns the decoded payload.
 * @param {string} token - The JWT to decode.
 * @returns {object|null} - The decoded object payload if decoding is successful, otherwise null.
 */
function JwtDecode(token) {
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const obj = JSON.parse(atob(base64));
    return obj;
  } catch (error) {
    // TODO: log the error here
    return null;
  }
}

module.exports = {
  JwtDecode: JwtDecode,
};
